import React from "react";
import { Loader, Modal as RsModal } from "rsuite";
import "./tAndCModal.scss";

function TAndCModal({ showTAndCModal, setShowTAndCModal }) {
  return (
    <RsModal
      open={showTAndCModal}
      onClose={() => setShowTAndCModal(false)}
      dialogClassName="tAndC-Modal"
      // centered
      size="full"
    >
      <RsModal.Header closeButton>
        <RsModal.Title className="tAndC-Modal__title">
          Terms and Conditions
        </RsModal.Title>
      </RsModal.Header>
      <RsModal.Body className="p-4 px-5">
        <p className="tAndC-Modal__main_heading">
          Interpretation and Definitions
        </p>
        <p className="tAndC-Modal__sub_heading">Interpretation</p>
        <br />
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions.
        <br />
        <br />
        The following definitions shall have the same meaning regardless of
        whether they appear in singular or in plural.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Definitions</p>
        <br />
        For the purposes of these Terms and Conditions:
        <br />
        <br />
        Affiliate means an entity that controls, is controlled by or is under
        common control with a party, where “control” means ownership of 50% or
        more of the shares, equity interest or other securities entitled to vote
        for the election of directors or other managing authority.
        <br />
        <br />
        Company(referred to as either “the Company”, “We”, “Us” or “Our” in this
        Agreement) refers to Growing Stars, 4695 Chabot Drive, Ste. 200,
        Pleasanton CA 94588.
        <br />
        <br />
        Country refers to: California, United States
        <br />
        <br />
        Service refers to the Website.
        <br />
        <br />
        Terms and Conditions(also referred as “Terms”) mean these Terms and
        Conditions that form the entire agreement between You and the Company
        regarding the use of the Service. This Terms and Conditions agreement as
        been created with the help of Terms and Conditions Generator.
        <br />
        <br />
        Third-party Social Media Service means any services or content
        (including data, information, products or services) provided by a
        third-party that may be displayed, included or made available by the
        Service.
        <br />
        <br />
        Website refers to Growing Stars, accessible from
        https://www.growingstars.com
        <br />
        <br />
        You means the individual accessing or using the Service, or the company,
        or other legal entity on behalf of which such individual is accessing or
        using the Service, as applicable.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Acknowledgment</p>
        <br />
        These are the Terms and Conditions governing the use of this Service and
        the agreement that operates between You and the Company. These Terms and
        Conditions set out the rights and obligations of all users regarding the
        use of the Service.
        <br />
        <br />
        Your access to and use of the Service is conditioned on Your acceptance
        of and compliance with these Terms and Conditions. These Terms and
        Conditions apply to all visitors, users and others who access or use the
        Service.
        <br />
        <br />
        By accessing or using the Service You agree to be bound by these Terms
        and Conditions. If You disagree with any part of these Terms and
        Conditions then You may not access the Service.
        <br />
        <br />
        Your access to and use of the Service is also conditioned on Your
        acceptance of and compliance with the Privacy Policy of the Company. Our
        Privacy Policy describes Our policies and procedures on the collection,
        use, and disclosure of Your personal information when You use the
        Application or the Website and tells You about Your privacy rights and
        how the law protects You. Please read Our Privacy Policy carefully
        before using Our Service.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading"> Links to Other Websites</p>
        <br />
        Our Service may contain links to third-party web sites or services that
        are not owned or controlled by the Company.
        <br />
        <br />
        The Company has no control over, and assumes no responsibility for, the
        content, privacy policies, or practices of any third-party web sites or
        services. You further acknowledge and agree that the Company shall not
        be responsible or liable, directly or indirectly, for any damage or loss
        caused or alleged to be caused by or in connection with the use of or
        reliance on any such content, goods or services available on or through
        any such web sites or services.
        <br />
        <br />
        We strongly advise You to read the terms and conditions and privacy
        policies of any third-party web sites or services that You visit.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Termination</p>
        <br />
        We may terminate or suspend Your access immediately, without prior
        notice or liability, for any reason whatsoever, including without
        limitation if You breach these Terms and Conditions.
        <br />
        <br />
        Upon termination, Your right to use the Service will cease immediately.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Limitation of Liability</p>
        <br />
        Notwithstanding any damages that You might incur, the entire liability
        of the Company and any of its suppliers under any provision of this
        Terms and Your exclusive remedy for all of the foregoing shall be
        limited to the amount actually paid by You through the Service or 100
        USD if You haven’t purchased anything through the Service.
        <br />
        <br />
        To the maximum extent permitted by applicable law, in no event shall the
        Company or its suppliers be liable for any special, incidental,
        indirect, or consequential damages whatsoever (including, but not
        limited to, damages for loss of profits, loss of data or other
        information, for business interruption, for personal injury, loss of
        privacy arising out of or in any way related to the use of or inability
        to use the Service, third-party software and/or third-party hardware
        used with the Service, or otherwise in connection with any provision of
        this Terms), even if the Company or any supplier has been advised of the
        possibility of such damages and even if the remedy fails of its
        essential purpose.
        <br />
        <br />
        Some states do not allow the exclusion of implied warranties or
        limitation of liability for incidental or consequential damages, which
        means that some of the above limitations may not apply. In these states,
        each party’s liability will be limited to the greatest extent permitted
        by law.
        <br />
        <br />
        Limitations may not apply to You. But in such a case the exclusions and
        limitations set forth in this section shall be applied to the greatest
        extent enforceable under applicable law.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Services</p>
        <br />
        The Site offers one on one tutoring services. You and the Tutor are
        responsible for materials, scheduling, frequency, duration and all other
        aspects of the transactions. You are responsible for choosing the best
        Tutor to fit your needs. You should investigate and review each user. If
        You are younger than 18-years old, the session should be supervised by
        an adult. The Website may vary depending on your location. We will
        attempt to deliver correspondence; however, We cannot guarantee delivery
        of messages. <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Academic Honesty</p>
        <br />
        We do not permit cheating of any kind. You are not to use the Website
        for academic dishonesty. We do not permit taking quizzes on behalf of
        somebody else or to work in violation of academic policies.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Obligations and Conduct</p>
        <br />
        You must: (a) be of legal age, (b) have the capacity to agree to these
        Terms on your behalf, (c) reside within the United States of America,
        (d) provide accurate information, (d) maintain the security of your User
        credentials. You are not permitted to use the Site if you are under the
        age of 13. Growing Stars does not permit inaccurate, harmful,
        pornographic, defamatory, racist, harassing, violent or offensive
        Content. You may not infringe on intellectual property. Growing Stars
        reserve all of its rights under the Communications Decency Act,
        including the rights to remove anything objectionable.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Confidentiality</p>
        <br />
        If you obtain direct access via the Website, all valuable information
        should be reasonably understood as confidential. You must hold
        Confidential Information in strict confidence.
        <br />
        <br />
        Confidential Information is not permitted to be shared or violated.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Site Content</p>
        <br />
        Growing Stars does not claim ownership of the Content that you provide.
        We have no obligation of any kind with respect to such Content. We are
        free to use such Content on an unrestricted basis. You grant Growing
        Stars a worldwide, royalty-free, nonexclusive license to use, reproduce,
        modify, resell or distribute Content. You warrant that you have proper
        authorization for the worldwide transfer and processing of Content and
        third-party providers.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">
          Terms of Transacting Business
        </p>
        <br />
        You must abide by the Website payment policies. You must pay all costs
        such as: Tutors hourly rate, services fees, and the Platform fee.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Advertising and Promotions</p>
        <br />
        We may run advertisements and promotions on the Website or our partner
        networks. Growing Stars is not responsible for loss or damage of such
        dealings or as the result of the presence of such non-Growing Stars
        Users.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Intellectual Property</p>
        <br />
        We grant you permission to use the Website for the purposes provided.
        You are permitted to use the Website for personal, non-commercial use.
        You are not permitted to remove any trademark, copyright or other
        notice. You may not incorporate information, content or materials. You
        are not permitted to deep-link to the Website for any purpose. We
        reserve all rights against any entity who violates this paragraph. You
        agree to not reproduce, modify, rent, lease loan, mirror, frame,
        republish, or modify the Website’s Content. We Trademark all marks,
        names, brands, logos, designs, slogans, and Content. You are not
        permitted to remove or alter Trademarks.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Copyright</p>
        <br />
        Growing Stars respects the intellectual property of You and Tutors.
        Users may not post, modify, or reproduce Content on the Website that is
        Copyrighted. You must obtain the prior written consent of the Copyright
        Owner to distribute Content. We reserve the right to remove any Content
        that infringes the Copyright Rights of Users.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Warranty Disclaimer </p>
        <br />
        Use of the Website is at your own sole risk. The Website, information,
        services, and Content is provided as is, as available and with all
        faults. We express implied conditions, representations and warranties of
        any kind. Growing Stars makes no representations, warranties, conditions
        as to the usefulness of quality, truth, accuracy or completeness of the
        Website.
        <br />
        <br />
        Growing Stars does not ensure that the Website is uninterrupted,
        error-free, quality of products, quality of services, or quality of
        Content. You assume all risk for damage to your computer system or loss
        of data that results from Website.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Assumption of Risk </p>
        <br />
        You assume all risks when using the Website. Risks include association
        with any online or offline interactions with other Users. You shall take
        precautions and follow recommendations by Growing Stars.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Indemnification </p>
        <br />
        You shall indemnify, defend and hold harmless Growing Stars and all
        affiliations. Any costs, including losses, expenses, claims, attorney
        fees and court costs, incurred by Growing Stars in any way related to
        Your acts or omissions, violation of any rights, breach of these Terms,
        disputes with or between other Users, use and/or misuse of the Website,
        violation of law or regulation, misleading or inaccurate information,
        misstatements, use of links to third party websites. Growing Stars
        reserves the right to assume the defense and control of any matter
        otherwise subject to indemnification by Users. You shall not settle or
        claim or matter on behalf of Growing Stars without Our written consent.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Injunction </p>
        <br />
        This section discusses the process of resolving disputes between Growing
        Stars and a parent; Growing Stars and a Student; or Growing Stars, a
        Tutor and a Guardian. All disputes are to be solved through arbitration
        instead of court.
        <br />
        <br />
        Any dispute must go to binding Arbitration under the provisions of the
        Terms. The arbitrator must apply the Consumer Arbitration Rules of the
        American Arbitration Association in effect at the time you consent to
        the Terms. If Consumer Arbitration Rules and Arbitration disagree, then
        the terms of this document would result in an unfair arbitration
        proceeding. In any case, the Consumer Arbitration Rules control. This
        arbitration provision must be construed and enforced following the
        Federal Arbitration Act, 9 U.S.C. §1 et seq.
        <br />
        <br />
        The Arbitration Process: (1) Complete a short form on AAA claim filing
        page, (2) Submit to the AAA, (3) Send a copy to Growing Stars, Attn:
        Legal Department. For more information, see the AAA’s claim filing page:
        http://www.adr.org/fileacase.
        <br />
        <br />
        Choosing the Arbitrator: Growing Stars and you will attempt to agree on
        a single arbitrator using AAA procedures. If agreement is impossible,
        each party is to select its own arbitrator. The Arbitrator’s Decision:
        Must be based on his/her decision on the evidence presented according to
        these Terms. The arbitrator may award damage and relief on an individual
        basis. The Arbitrator’s decision is final and binding.
        <br />
        <br />
        For Individual Claims: You and Growing Stars Agree that each may bring
        claims, suits, cause of action against the other on an individual basis.
        A representative claim may be brought in Arbitration where otherwise
        mandated by law. The arbitrator may not consolidate more than one
        person’s claims and may not preside over any consolidates,
        representative or class proceeding. Location of Hearing: To be conducted
        at a convenient location for all parties. Attorney Fee: Each party will
        pay own attorneys’ fees. Disputes: May be brought before an
        administrative agency. Nothing in the arbitration provision relieves any
        party the duty to exhaust administrative remedies or prevents either
        party from cooperating with a state body as required by law.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Notice</p>
        <br />
        We may provide notice to Users via email, posting links or letter mail
        on the Site. Growing Stars reserves the right to modify, terminate or
        suspend services. We may delete all related information and files.
        Growing Stars is not liable to Users or any third-party for
        modification, suspension or termination of services.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Governing Law</p>
        <br />
        The laws of the Country, excluding its conflicts of law rules, shall
        govern this Terms and Your use of the Service. Your use of the
        Application may also be subject to other local, state, national, or
        international laws.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Disputes Resolution</p>
        <br />
        If You have any concerns or disputes about the Service, You agree to
        first try to resolve the dispute informally by contacting the Company.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">
          The United States Legal Compliance
        </p>
        <br />
        You represent and warrant that (i) You are not located in a country that
        is subject to the United States government embargo, or that has been
        designated by the United States government as a “terrorist supporting”
        country, and (ii) You are not listed on any United States government
        list of prohibited or restricted parties.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Severability</p>
        <br />
        If any provision of these Terms is held to be unenforceable or invalid,
        such provision will be changed and interpreted to accomplish the
        objectives of such provision to the greatest extent possible under
        applicable law and the remaining provisions will continue in full force
        and effect.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Waiver</p>
        <br />
        Except as provided herein, the failure to exercise a right or to require
        performance of an obligation under this Terms shall not effect a party’s
        ability to exercise such right or require such performance at any time
        thereafter nor shall be the waiver of a breach constitute a waiver of
        any subsequent breach.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Translation Interpretation</p>
        <br />
        These Terms and Conditions may have been translated if We have made them
        available to You on our Service.
        <br />
        <br />
        You agree that the original English text shall prevail in the case of a
        dispute.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">
          Changes to These Terms and Conditions
        </p>
        <br />
        We reserve the right, at Our sole discretion, to modify or replace these
        Terms at any time. If a revision is material We will make reasonable
        efforts to provide at least 30 days’ notice prior to any new terms
        taking effect. What constitutes a material change will be determined at
        Our sole discretion.
        <br />
        <br />
        By continuing to access or use Our Service after those revisions become
        effective, You agree to be bound by the revised terms. If You do not
        agree to the new terms, in whole or in part, please stop using the
        website and the Service.
        <br />
        <br />
        <p className="tAndC-Modal__sub_heading">Contact Us</p>
        <br />
        If you have any questions about these Terms and Conditions, You can
        contact us:
        <br />
        <br />
        By email: inquiries@growingstars.com
        <br />
        <br />
        By phone number: 1.800.499.4769
        <br />
        <br />
        <p>Last updated: February 06, 2020</p>
      </RsModal.Body>
    </RsModal>
  );
}

export default TAndCModal;
